import { makeStyles, Button } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import BackForwardButton from '../../Shared/BackForwardButton';
import { machineScissorZone } from '../../../Config/constants'
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import { useTranslation } from 'react-i18next';
import { configureZonesByProductionOrderLines } from '../../../Helpers/OrderInfoHelper';
import { fromNewDateFormatToDDMMYYYYHHmmssSlash } from '../../../Helpers/dateHelper'
import QualityCheckOverviewTable from '../../QualityCheck/QualityCheckOverviewTable';
import QualityCheckDetailOverviewTable from '../../QualityCheck/QualityCheckDetailOverviewTable'
import TakeSampleDialog from '../../Shared/Dialogs/TakeSampleDialog';
import { useHistory } from 'react-router-dom';
import { dataService } from '../../../Services/data.service';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';

export const QualityChecksPage = (props) => {
    const classes = useStyles();
    let history = useHistory();

    const [showDetailContent, setShowDetailContent] = useState(false);
    const [sampleDialogOpen, setSampleDialogOpen] = useState(false);
    const [dialogTitle, setDialogTitle] = useState(null);
    const [dialogContext, setDialogContext] = useState(null);
    const [productionOrder, setProductionOrder] = useState(null);
    const [qualitySamples, setQualitySamples] = useState([]);
    const [detailDate, setDetailDate] = useState(null);
    const [zonesWithScissors, setZonesWithScissors] = useState([]);
    const [allZones, setAllZones] = useState([]);

    const { t } = useTranslation();

    useEffect(() => {
        dataService.getOrderDetailsByOrderId(parseInt(props.match.params.id)).then(order => {
            setProductionOrder(order);
            dataService.getQualitySamplesByProductionOrderId(props.match.params.id).then(samples => {
                setQualitySamples(samples);
            }).catch((error) => { toast.error(error, { position: "top-center" }) });
        }).catch((error) => { toast.error(error, { position: "top-center" }) });

        dataService.getProductionOrdersByMachine(props.workstation.selectedWorkstation).then(orders => {
            dataService.getMachinesByMachineType(machineScissorZone).then(zones => {
                setAllZones(zones);
                let configuredZones = configureZonesByProductionOrderLines(orders, zones);
                setZonesWithScissors(configuredZones);
            }).catch((error) => { toast.error(error, { position: "top-center" }) });
        }).catch((error) => { toast.error(error, { position: "top-center" }) });

    }, [props.workstation.selectedWorkstation, props.match.params.id]);

    const createNewQualityCheck = () => {
        setDialogTitle(t("Take a sample") + "!");
        if (props.workstation.selectedZone) {
            setDialogContext(t("PLATE measurement from LINE ") + productionOrder.machinePlannedCode + " zone " + props.workstation.selectedZone);
        }
        else {
            setDialogContext(t("PLATE measurement from LINE ") + productionOrder.machinePlannedCode);
        }

        setSampleDialogOpen(true);
    }

    const showDetails = (date) => {
        setDetailDate(fromNewDateFormatToDDMMYYYYHHmmssSlash(date));
        setShowDetailContent(true);
    }

    const performTest = (palletnumber, progress, selectedZones) => {
        let machineId = props.workstation.selectedWorkstation;
        if (selectedZones.length > 0) {
            let zone = allZones.find(x => x.name === selectedZones[0].zone && x.code.includes(productionOrder.machineCode));
            if (zone) {
                machineId = zone.id;
            }
        }
        history.push('/sampling/' + props.match.params.id + '/' + palletnumber + "/" + props.match.params.progress + "/0/" + machineId+ "/overview/"  + props.match.params.orderLineId);
    };

    const goToOrder = () => {
        history.push('/order/' + props.match.params.id + '/' + props.match.params.orderLineId);
    }

    const goToOverview = () => {
        setShowDetailContent(false);
    }

    let dimensions = "";
    let palletprogress = "";
    let articleName = "";
    let articleDescription = "";
    let totalPallets = "";
    let producedPieces = "";
    let totalPieces = "";
    let quality = "";
    if (productionOrder) {
        var productMetaDataType1 = JSON.parse(productionOrder.bomOut[0].productMetaData).find(x => x.MetaDataType === 1);
        var productMetaDataType2 = JSON.parse(productionOrder.bomOut[0].productMetaData).find(x => x.MetaDataType === 2);
        dimensions = productMetaDataType1.MetaData[0].Width.Value + "x" + productMetaDataType1.MetaData[0].Length.Value + "x" + productMetaDataType1.MetaData[0].Thickness.Value;
        quality = productMetaDataType2.MetaData[0].Quality;
        palletprogress = props.match.params.progress;
        articleName = productionOrder.bomOut[0].productName;
        articleDescription = productionOrder.bomOut[0].productDescription;
        totalPieces = productionOrder.bomOut[0].quantityToProduce;
        producedPieces = parseInt(props.match.params.progress) * productionOrder.bomOut[0].quantityOnCarrier;
        if (producedPieces > totalPieces) {
            producedPieces = totalPieces;
        }
        totalPallets = Math.ceil(productionOrder.bomOut[0].quantityToProduce / productionOrder.bomOut[0].quantityOnCarrier);
    }

    return (

        <React.Fragment>
            {qualitySamples && productionOrder ? <div className={classes.background}>
                <div className={classes.qualityChecks}>
                    <div className={classes.header}>
                        <div className={classes.left}>
                            <div className={classes.back}>
                                <BackForwardButton textOverride={t("Back to order ") + productionOrder.reference} action={goToOrder} direction={'Back'}></BackForwardButton>
                                {showDetailContent &&
                                    <React.Fragment>
                                        <span>/</span>
                                        <BackForwardButton textOverride={" quality checks PLATE"} action={goToOverview}></BackForwardButton>
                                    </React.Fragment>
                                }

                            </div>
                            <div className={classes.title}>
                                {t("Quality checks PLATE")}
                            </div>
                            <div className={classes.subTitle}>
                                {"Order " + productionOrder.reference}
                            </div>
                        </div>
                        <div className={classes.right}>
                            <Button className={classes.newQualityCheckButton} onClick={() => createNewQualityCheck()}>
                                <AddRoundedIcon className={classes.addIcon}></AddRoundedIcon>
                                <div className={classes.buttonText}>{t("NEW QUALITY CHECK")}</div>
                            </Button>
                        </div>
                    </div>
                    <div className={classes.generalInfoContainer}>
                        <div className={classes.upperInfoContainer}>
                            <div className={classes.upperHeaderColumn1}>
                                <div className={classes.infoTitle}>{t("Client")}</div>
                                <div className={classes.upperInfo}>{productionOrder.customerName}</div>
                            </div>
                            <div className={classes.upperHeaderColumn2}>
                                <div className={classes.infoTitle}>Operator</div>
                                <div className={classes.upperInfo}>{props.user.userInfo.given_name}</div>
                            </div>
                        </div>
                        <div className={classes.lowerInfoContainer}>
                            <div className={classes.lowerHeaderColumn1}>
                                <div className={classes.infoTitle}>{t("Article")}</div>
                                <div className={classes.lowerInfo}>{articleName}</div>
                            </div>
                            <div className={classes.lowerHeaderColumn2}>
                                <div className={classes.infoTitle}>{t("Description")}</div>
                                <div className={classes.lowerInfo}>{articleDescription}</div>
                            </div>
                            <div className={classes.lowerHeaderColumn3}>
                                <div className={classes.infoTitle}>{t("Dimensions")}</div>
                                <div className={classes.lowerInfo}>{dimensions}</div>
                            </div>
                            <div className={classes.lowerHeaderColumn4}>
                                <div className={classes.infoTitle}>{t("Pallets")}</div>
                                <div className={classes.lowerInfo}>{palletprogress + "/" + totalPallets}</div>
                            </div>
                            <div className={classes.lowerHeaderColumn5}>
                                <div className={classes.infoTitle}>{t("Produced pieces")}</div>
                                <div className={classes.lowerInfo}>{producedPieces + "/" + totalPieces}</div>
                            </div>
                            <div className={classes.lowerHeaderColumn6}>
                                <div className={classes.infoTitle}>{t("Quality")}</div>
                                <div className={classes.lowerInfo}>{quality}</div>
                            </div>
                            <div className={classes.lowerHeaderColumn7}>
                                <div className={classes.infoTitle}>{t("Date")}</div>
                                <div className={classes.lowerInfo}>{fromNewDateFormatToDDMMYYYYHHmmssSlash(new Date())}</div>
                            </div>
                        </div>
                    </div>
                    {showDetailContent ? <QualityCheckDetailOverviewTable {...props} qualitySamples={qualitySamples} orderId={props.match.params.id} detailDate={detailDate}></QualityCheckDetailOverviewTable> :
                        <QualityCheckOverviewTable qualitySamples={qualitySamples} orderId={props.match.params.id} {...props} operator={props.user.userInfo.given_name} totalPallets={totalPallets} showDetails={showDetails}></QualityCheckOverviewTable>}
                </div>
                {(allZones.length > 0 && sampleDialogOpen) &&
                    <TakeSampleDialog zones={allZones} {...props} zonesWithScissors={zonesWithScissors} closeDialog={() => setSampleDialogOpen(false)} progress={props.match.params.progress} productionOrder={productionOrder} dialogOpen={sampleDialogOpen} action={performTest} dialogTitle={dialogTitle} dialogContext={dialogContext} piecesPerPallet={productionOrder.bomOut[0].quantityOnCarrier}></TakeSampleDialog>
                }
            </div> : <React.Fragment></React.Fragment>}
        </React.Fragment>
    )
}

const useStyles = makeStyles({
    filterBar: {
        width: "210px",
        backgroundColor: "#DEDEDE",
        float: "left",
        height: "100%",
        padding: "20px",
        paddingLeft: "0px",
        paddingTop: "30px",
        boxSizing: 'border-box'
    },
    qualityChecks: {
        width: "100%",
        float: "left",
        padding: "15px",
        boxSizing: 'border-box'
    },
    navButton: {
        textDecoration: "none"
    },
    back: {
        display: 'block'
    },
    title: {
        display: 'block',
        fontSize: "22px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",
        marginLeft: "5px",
        marginTop: "10px",
        marginBottom: "10px"
    },
    subTitle: {
        display: 'block',
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",
        marginLeft: "5px",
        marginBottom: "20px"
    },
    right: {
        float: 'right'
    },
    left: {
        float: "left"
    },
    newQualityCheckButton: {
        backgroundColor: FlagstoneTheme.palette.primary.main,
        width: "auto",
        height: "40px",
        paddingLeft: "5px !important",
        marginTop: "20px",
        "&:hover": {
            background: FlagstoneTheme.palette.primary.main
        }
    },
    addIcon: {
        color: "white",
        float: "left"
    },
    buttonText: {
        color: 'white',
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        float: "left",
        paddingTop: "2px",
        marginLeft: "2px",
        marginRight: "5px"

    },
    download: {
        marginLeft: "10px"
    },
    generalInfoContainer: {
        backgroundColor: "white",
        padding: "20px",
        borderRadius: "6px",
        marginLeft: "5px",
        marginBottom: "10px"
    },
    header: {
        height: "150px"
    },
    background: {
        paddingTop: "20px",
        position: "relative",
        width: "100%"    },
    upperInfoContainer: {
        width: "100%",
        height: "80px",
        borderBottom: "1px solid #DEDEDE"
    },
    lowerInfoContainer: {
        width: "100%",
        height: "80px",
        paddingTop: "20px",
        boxSizing: "border-box"
    },
    upperHeaderColumn1: {
        width: "80%",
        height: "80px",
        float: "left"
    },
    upperHeaderColumn2: {
        width: "20%",
        height: "80px",
        float: "left"
    },
    lowerHeaderColumn1: {
        width: "14%",
        height: "80px",
        float: "left"
    },
    lowerHeaderColumn2: {
        width: "26%",
        height: "80px",
        float: "left"
    },
    lowerHeaderColumn3: {
        width: "12%",
        height: "80px",
        float: "left"
    },
    lowerHeaderColumn4: {
        width: "8%",
        height: "80px",
        float: "left"
    },
    lowerHeaderColumn5: {
        width: "10%",
        height: "80px",
        float: "left"
    },
    lowerHeaderColumn6: {
        width: "10%",
        height: "80px",
        float: "left"
    },
    lowerHeaderColumn7: {
        width: "18%",
        height: "80px",
        float: "left"
    },
    infoTitle: {
        color: '#8D8D8D',
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        marginTop: "10px"
    },
    upperInfo: {
        color: '#020100',
        fontSize: "22px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        marginTop: "5px"
    },
    lowerInfo: {
        color: '#020100',
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        marginTop: "5px"
    },
});

function mapStateToProps(state) {
    return {
        workstation: state.workstation
    }
}

export default connect(mapStateToProps)(QualityChecksPage)